import { useCallback, useContext } from "react";
import { useQuery } from "react-query";

import { UseQueryProps } from "../../interfaces";
import { apiServiceContext } from "../../api-service-context";
import { QueryKeys } from "../query-keys";

export const useBookmarkFolderAll = <TData = any, TError = any>(
  queryOptions: UseQueryProps<TData, TError> = {}
) => {
  const { bookmarksApiService } = useContext(apiServiceContext);
  const queryFn = useCallback(
    () =>
      bookmarksApiService.createCancellableRequest((cancelToken) =>
        bookmarksApiService.getBookmarkFolderAll(cancelToken)
      ),
    [bookmarksApiService]
  );

  return useQuery(QueryKeys.bookmarkFolderAll(), queryFn, queryOptions);
};
